import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import { ROUTES } from "../constants/routes";
import SessionHandler from "../views/components/sessionHandler";
import { AuthPage } from "../views/pages/auth";

export const Router = () => {
  return (
    <BrowserRouter>
      <SessionHandler>
        <Routes>
          <Route path={ROUTES.ROOT} Component={AuthPage} />

          <Route path="*" element={<Navigate to={ROUTES.ROOT} />} />
        </Routes>
      </SessionHandler>
    </BrowserRouter>
  );
};
